import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/phone-messages")({
  component: lazyRouteComponent(() => import("./-pages/admin.phone-messages")),
  head: () => ({ meta: [{ title: "Phone Messages — Admin" }] }),
});
